export function normalizeCheckoutDraftRevision(value) {
  const revision = Number(value);
  return Number.isSafeInteger(revision) && revision >= 0 ? revision : 0;
}

export function isCheckoutDraftRevisionConflict(error) {
  if (!error) return false;
  if (String(error.code || "") === "40001") return true;
  const message = `${error.message || ""} ${error.details || ""}`.toLowerCase();
  return message.includes("checkout draft changed")
    || message.includes("draft changed after this payment review");
}

export async function saveCheckoutDraftWithRevision({
  rpc,
  appointmentId,
  draft,
  expectedRevision,
}) {
  const { data, error } = await rpc("save_checkout_draft_v2", {
    p_appointment_id: appointmentId,
    p_draft: draft,
    p_expected_revision: normalizeCheckoutDraftRevision(expectedRevision),
  });
  if (error) throw error;

  return {
    draftData: data?.draft_data && typeof data.draft_data === "object"
      ? data.draft_data
      : draft,
    revision: normalizeCheckoutDraftRevision(data?.revision),
    updatedAt: data?.updated_at || null,
  };
}

export async function discardCheckoutDraftWithRevision({
  rpc,
  appointmentId,
  draft,
  expectedRevision,
}) {
  const { data, error } = await rpc("discard_checkout_draft_v2", {
    p_appointment_id: appointmentId,
    p_draft: draft,
    p_expected_revision: normalizeCheckoutDraftRevision(expectedRevision),
  });
  if (error) throw error;

  return {
    draftData: data?.draft_data && typeof data.draft_data === "object"
      ? data.draft_data
      : null,
    revision: normalizeCheckoutDraftRevision(data?.revision),
    updatedAt: data?.updated_at || null,
  };
}
